export const DISABLE_HOVER_ON_CHILD = 'disable_hover_on_child'
